import { Soup } from "lucide-react";

export function BrandLogo({ size = "md", light = false, showTagline = false }) {
  const dims = { sm: "h-8 w-8", md: "h-10 w-10", lg: "h-14 w-14" }[size];
  const title = { sm: "text-base", md: "text-lg", lg: "text-2xl" }[size];
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className={`${dims} rounded-xl grid place-items-center bg-[#1B5E20] shadow-md relative overflow-hidden`}>
        <div className="absolute inset-0 bg-[#FFB300]" style={{ clipPath: "polygon(0 62%,100% 40%,100% 100%,0 100%)" }} />
        <Soup className="relative text-[#FFB300]" size={size === "lg" ? 30 : 22} strokeWidth={2.2} />
      </div>
      <div className="leading-none">
        <div className={`font-display font-extrabold tracking-tight ${title} ${light ? "text-white" : "text-[#1B5E20]"}`}>
          MisterMic's <span className="text-[#C62828]">AngelSabaw</span>
        </div>
        {showTagline && (
          <div className={`text-[10px] font-bold tracking-[0.2em] mt-1 ${light ? "text-[#FFB300]" : "text-[#B78103]"}`}>
            GOOD SOUP. GOOD DAY.
          </div>
        )}
      </div>
    </div>
  );
}
